import React, { useState, useEffect } from 'react';
import AdminLayout from './AdminLayout';
import HealthProfessionalsManager from './HealthProfessionalsManager';
import ConsultationRequestsManager from './ConsultationRequestsManager';
import PromoCodeManager from './PromoCodeManager';

interface AdminAppProps {
  onBackToApp: () => void;
}

interface ConsultationRequest {
  id: string;
  requestId: string;
  patientName: string;
  patientEmail: string;
  patientPhone?: string;
  symptoms: string[];
  status: string;
  paymentStatus?: string;
  requestedDate: string;
  requestedSpecificTime?: string; // ✅ NEW: Specific time
  requestedTimeRangeStart?: string; // DEPRECATED
  requestedTimeRangeEnd?: string; // DEPRECATED
  timezone?: string;
  createdAt: string;
  amount?: number;
}

const AdminApp: React.FC<AdminAppProps> = ({ onBackToApp }) => {
  const [activeTab, setActiveTab] = useState<'professionals' | 'requests' | 'promoCodes'>('requests');
  const [requests, setRequests] = useState<ConsultationRequest[]>([]);
  const [requestsLoading, setRequestsLoading] = useState(true);
  const [requestsError, setRequestsError] = useState<string | null>(null);

  console.log('🔍 AdminApp rendering - activeTab:', activeTab);

  const fetchRequests = async () => {
    setRequestsLoading(true);
    setRequestsError(null);
    
    console.log('🔥 API CALL: Fetching consultation requests...');
    
    try {
      const authToken = localStorage.getItem('authToken');
      
      if (!authToken) {
        throw new Error('Not authenticated');
      }

      const apiUrl = `${process.env.REACT_APP_API_URL || 'https://0guzh8ema9.execute-api.us-east-1.amazonaws.com/prod'}/admin/consultation-requests`;

      const response = await fetch(apiUrl, {
        headers: {
          'Authorization': `Bearer ${authToken}`,
          'Content-Type': 'application/json'
        }
      });

      if (!response.ok) {
        throw new Error('Failed to fetch requests');
      }

      const data = await response.json();
      console.log('✅ Consultation requests loaded -', data.requests?.length || 0, 'requests');
      
      setRequests(data.requests || []);
    } catch (err: any) {
      console.error('❌ Error fetching requests:', err);
      setRequestsError(err.message);
    } finally {
      setRequestsLoading(false);
    }
  };

  useEffect(() => {
    console.log('🔥 AdminApp mounted - Loading consultation requests ONCE');
    fetchRequests();
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  return (
    <AdminLayout onBackToApp={onBackToApp} activeTab={activeTab} onTabChange={setActiveTab}>
      <div style={{ display: activeTab === 'professionals' ? 'block' : 'none' }}>
        <HealthProfessionalsManager />
      </div>
      <div style={{ display: activeTab === 'requests' ? 'block' : 'none' }}>
        <ConsultationRequestsManager 
          requests={requests}
          loading={requestsLoading}
          error={requestsError}
          onRefresh={fetchRequests}
        />
      </div>
      <div style={{ display: activeTab === 'promoCodes' ? 'block' : 'none' }}>
        <PromoCodeManager />
      </div>
    </AdminLayout>
  );
};

export default AdminApp;